import React from "react";
import { Route, IndexRoute, Redirect } from "react-router";
import App from "./components/App";
import routesConfig from "./configurations/routesConfig";
import Constants from "./configurations/constants";
import DashboardPage from "./components/dashboard/dashboardPage";

let routes = [];
for (var route in routesConfig) {
  routes.push(routesConfig[route]);
}
export default (
  <Route
    name="Arbiter Multipay Home"
    path={`${Constants.ROUTES_BASE_CONTEXT_PATH}`}
    component={App}
  >
      <Redirect exact path="/" to={`${Constants.ROUTES_BASE_CONTEXT_PATH}`} />
    <IndexRoute component={DashboardPage} />
    {routes.map(route => {
      return (
        <Route
          name={route.name}
          key={route.key}
          path={route.path}
          exact={route.exact}
          component={route.pageComponent}
        />
      );
    })}
  </Route>
);



// WEBPACK FOOTER //
// ./src/routes.js